/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const LightBulb = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M9 23.25H15V21.75H9V23.25ZM12 1C16.4183 1 20 4.58172 20 9C20 12.1048 18.2313 14.7965 15.6465 16.1225L15 20H9L8.35448 16.123C5.76915 14.7972 4 12.1052 4 9C4 4.58172 7.58172 1 12 1ZM12 2.5C8.41015 2.5 5.5 5.41015 5.5 9C5.5 11.4653 6.88366 13.683 9.03896 14.7883L9.71022 15.1325L10.271 18.5H13.729L14.2909 15.132L14.9618 14.7879C17.1167 13.6824 18.5 11.4649 18.5 9C18.5 5.41015 15.5899 2.5 12 2.5ZM13 4.25C15.0711 4.25 16.75 5.92893 16.75 8H15.25C15.25 6.75736 14.2426 5.75 13 5.75V4.25Z"
                        fill={color}
                    />
                </svg>
        );
    };
